module.exports = __webpack_public_path__ + "static/media/location-big.c1cfd4c2.svg";